/**
 * Here we configure and render the react app.
 */

import 'normalize.css'
import './style/index.css'
import * as React from 'react'
import * as ReactDom from 'react-dom'
import App from './comp/app'
import './background-dots'


ReactDom.render(
  React.createElement(App, {}),
  document.getElementById('app')
)


// WEBPACK FOOTER //
// ./src/index.ts